import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import {
    BookingStatusService,
    BookingXStatus
} from 'libraries/component/booking/booking-status/booking-status.service';
import {
    faCheck,
    faCircle,
    faExclamation, faExclamationCircle, faExclamationTriangle,
    faInfo, faQuestion,
    faShoppingCart,
    faTimes,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";
import { IStatusColorationRule } from "libraries/component/status-tag/status-tag.component";

@Component({
    selector: 'booking-status',
    template: `
        <status-tag [icons]="icons"
                    [mode]="mode"
                    [label]="label"
                    [iconLabel]="iconLabel"
                    [statusColorationRule]="statusColorationRule"
                    [statusTranslated]="statusTranslated"
                    [breakLine]="breakLine"
                    [status]="status"></status-tag>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingStatusComponent implements OnChanges {

    @Input()
    public mode: 'icon' | 'label' | 'both'  = 'icon';

    @Input()
    public status: BookingXStatus;

    @Input()
    public label: string = Yii.t('wui-shared-js', 'Statut du dossier ');

    @Input()
    public breakLine: boolean = false;

    @Input()
    public statusColorationRule: IStatusColorationRule  = {
        green: "confirm",
        red: "actionRequired",
        grey: "cancel",
        orange: "unableToConfirm",
    };

    public circle: IconDefinition = faCircle;
    public test: IconDefinition = faCheck;
    public defaultStatus: BookingXStatus = BookingXStatus.Request;
    public iconLabel: string;
    public statusTranslated: string;

    constructor(
        private readonly bookingStatusService: BookingStatusService
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.label = this.mode !== 'both' ? Yii.t('wui-shared-js', 'Statut du dossier ') : null;
        this.iconLabel = this.getLabel();
        this.statusTranslated = this.getXStatusTranslated();
    }

    public getLabel(): string {
        const label: string = this.getXStatusTranslated();
        return `${this.label} : ${label}`;
    }

    public getXStatusTranslated(): string {
        return this.bookingStatusService.getStatusLabel(this.status);
    }

    public getWrapperClass(): string {
        return `${this.status}`;
    }

    public getIcon(): string {
        return `fa fa-stack-1x fa-inverse ${this.getStatusIcon()}`;
    }

    public icons: { [status: string]: IconDefinition } = {
        [BookingXStatus.Cancel]: faTimes,
        [BookingXStatus.Confirm]: faCheck,
        [BookingXStatus.OK]: faCheck,
        [BookingXStatus.Quote]: faShoppingCart,
        [BookingXStatus.Information]: faInfo,
        [BookingXStatus.ActionRequired]: faExclamation,
        [BookingXStatus.Danger]: faExclamation,
        [BookingXStatus.Request]: faQuestion,
        [BookingXStatus.Unknown]: faExclamationCircle,
        [BookingXStatus.unableToConfirm]: faExclamation,
        default: faExclamationTriangle,
    };

    public getStatusIcon(): string {
        switch (this.status) {
            case BookingXStatus.Cancel:
                return 'fa-times';
            case BookingXStatus.Confirm:
                return 'fa-check';
            case BookingXStatus.Quote:
                return 'fa-shopping-cart';
            case BookingXStatus.Information:
                return 'fa-info';
            case BookingXStatus.ActionRequired:
                return 'fa-exclamation';
            case BookingXStatus.Request:
            default:
                return 'fa-question';
        }
    }
}
